import { store } from "../../../store";

/**
 *
 * @param {String} scope - where authorization is being applied (e.g. issue, admin, etc.)
 * @param {String} action - what user is trying to obtain authorization for (e.g. view, create, update, delete)
 * @param {Number} level - minimum permission level for the requested action
 * @param {Number} controlledContentId - id of data where action is to be taken
 * @returns {Boolean}
 */
export default function qmsActionIsAuthorized(
  scope,
  action,
  level,
  controlledContentId = null
) {
  const qmsUser = store.getState().qms.qmsUser;
  const qmsUserRoles = store.getState().qms.userRoles || null;
  const qrps = store.getState().qms.qmsRolePermissions;

  // If qmsUser doesn't exist, or scope/action params are not provided, then do not authorize
  if (
    !qmsUser ||
    !scope ||
    !action ||
    !qrps ||
    !("permissionLevels" in qrps) ||
    !(scope in qrps.permissionLevels) ||
    !(action in qrps.permissionLevels[scope])
  ) {
    return false;
  }

  // If superuser, skip
  if (qrps.isSuperuser === true) return true;

  // ex. permissionLevels.ISSUE.edit >= 3
  if (qrps.permissionLevels[scope][action] >= level) {
    if (!controlledContentId) return true;

    if (!qrps.controlledContentIds || !(scope in qrps.controlledContentIds)) return false;
    if (qrps.controlledContentIds[scope].includes(controlledContentId)) return true;
  }
  return false;
}
